import { render } from "./ForbiddenError.vue?vue&type=template&id=26fe8e96"
import script from "./ForbiddenError.vue?vue&type=script&lang=js"
export * from "./ForbiddenError.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__